import { deserialize } from 'cerialize'

export class KindActModel {
	@deserialize public kind: string
	@deserialize public kind_translate: string
}
